// extracted by mini-css-extract-plugin
export default {"mainContainer":"mydownloads_mainContainer__+zm-1","cardSection":"mydownloads_cardSection__YirKa","heading":"mydownloads_heading__ePaiv"};